export const SAVE_DATA_ENTRY = '@@dataentry/SAVE_DATA_ENTRY';
export const LOAD_DATA_ENTRY_INTO_STORE =
  '@@dataentry/LOAD_DATA_ENTRY_INTO_STORE';
export const LOAD_COUNTIES_INTO_STORE = '@@dataentry/LOAD_COUNTIES_INTO_STORE';
export const LOAD_REPORT_TYPES_INTO_STORE =
  '@@dataentry/LOAD_REPORT_TYPES_INTO_STORE';
export const SEARCH_REPORTS = '@@dataentry/SEARCH_REPORTS';
export const OPEN_REPORT = '@@dataentry/OPEN_REPORT';
export const ASSIGN_AND_OPEN_REPORT = '@@dataentry/ASSIGN_AND_OPEN_REPORT';
export const UNASSIGN = '@@dataentry/UNASSIGN';
export const SAVE_CHECKERS = '@@dataentry/COMPLETE_PAPER_DATA_ENTRY';
export const REMOVE_FROM_RESULTS = '@@dataentry/REMOVE_FROM_RESULTS';
export const COMPLETE_DATA_ENTRY = '@@dataentry/COMPLETE_DATA_ENTRY';
export const GET_IMAGE = '@@dataentry/GET_IMAGE';
export const GET_FORM_40 = '@@dataentry/GET_FORM_40';
export const GET_FRONTSHEET = '@@dataentry/GET_FRONTSHEET';
export const COMPLETE_CHECKERS = '@@dataentry/COMPLETE';
